<div class="inicio">
  <br /><br />
  <p class="titulo">
    GESTIÓN DE EQUIPOS
    <mat-icon
      color="primary"
      matTooltip="Click para más información"
      (click)="botonInformacion()"
      >info</mat-icon
    >
  </p>

  <div class="grid-container">
    <div class="celda">
      <mat-label class="label"> Activo </mat-label>
      <mat-form-field appearance="outline">
        <mat-select
          placeholder="Selecciona el tipo de dispositivo"
          [formControl]="dispositivoSeleccionadoControl"
        >
          <mat-option
            *ngFor="let dispositivo of dispositivos"
            [value]="dispositivo"
            >{{ dispositivo }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="div">
    <mat-tab-group (selectedIndexChange)="myTabSelectedIndexChange($event)">
      <mat-tab label="Todos">
        <app-tabla-equipos
          [dataSource]="estadosEquipos.Todos.datasource"
          [cargando]="estadosEquipos.Todos.estado == 'cargando'"
          [pageIndex]="estadosEquipos.Todos.paginacion.page"
          [pageSize]="estadosEquipos.Todos.paginacion.size"
          [length]="estadosEquipos.Todos.paginacion.totalElements"
          [columnas]="encabezadostabla"
          tituloEstatus="ESTADO ACTUAL"
          campoEstatus="states_id"
          colorBoton="accent"
          (pageChange)="onPageTodos($event)"
          (verDetalle)="detalleEquipo($event)"
        ></app-tabla-equipos>
      </mat-tab>

      <mat-tab label="Asignados">
        <app-tabla-equipos
          [dataSource]="estadosEquipos.Asignados.datasource"
          [cargando]="estadosEquipos.Asignados.estado == 'cargando'"
          [pageIndex]="estadosEquipos.Asignados.paginacion.page"
          [pageSize]="estadosEquipos.Asignados.paginacion.size"
          [length]="estadosEquipos.Asignados.paginacion.totalElements"
          [columnas]="encabezadostabla"
          tituloEstatus="ASIGNADO A"
          campoEstatus="users_id"
          tooltipEstatus="Muestra el nombre de usuario, en caso de que el empleado no este actualizado en el EndPoint"
          colorBoton="accent"
          (pageChange)="onPageAsignados($event)"
          (verDetalle)="detalleEquipo($event)"
        ></app-tabla-equipos>
      </mat-tab>

      <mat-tab label="No asignados">
        <app-tabla-equipos
          [dataSource]="estadosEquipos.NoAsignados.datasource"
          [pageIndex]="estadosEquipos.NoAsignados.paginacion.page"
          [pageSize]="estadosEquipos.NoAsignados.paginacion.size"
          [length]="estadosEquipos.NoAsignados.paginacion.totalElements"
          [columnas]="encabezadostabla"
          tituloEstatus="SUCURSAL ACTUAL"
          campoEstatus="locations_id"
          colorBoton="accent"
          [cargando]="estadosEquipos.NoAsignados.estado == 'cargando'"
          (pageChange)="onPageNoAsignados($event)"
          (verDetalle)="detalleEquipo($event)"
        ></app-tabla-equipos>
      </mat-tab>

      <mat-tab label="Baja">
        <app-tabla-equipos
          [dataSource]="estadosEquipos.Baja.datasource"
          [pageIndex]="estadosEquipos.Baja.paginacion.page"
          [pageSize]="estadosEquipos.Baja.paginacion.size"
          [length]="estadosEquipos.Baja.paginacion.totalElements"
          [columnas]="encabezadostabla"
          tituloEstatus="CAUSA BAJA"
          campoEstatus="states_id"
          colorBoton=""
          estiloBoton="background-color: #f9df56; color: black"
          [cargando]="estadosEquipos.Baja.estado == 'cargando'"
          (pageChange)="onPageBaja($event)"
          (verDetalle)="detalleEquipo($event)"
        ></app-tabla-equipos>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
